import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';


@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  imports: [IonIcon]
})
export class PaginationComponent implements OnInit, OnChanges {

  /** The total number of records */
  @Input()
  public collectionSize = 10;

  /** The number of records to display */
  @Input()
  public pageSize = 5;

  /** Current page */
  @Input()
  public currentPage = 1;

  /** Display the Next/Previous buttons */
  @Input()
  public nextPreviousButtons = true;

  @Output() public callbackFunction: EventEmitter<number> = new EventEmitter();

  protected totalPages: any[] = [];

  protected currentPaginationState = 'LOWER';

  constructor() { }

  public ngOnInit(): void {
    this.updateCurrentPaginationState();
  }

  /** Update totalPage number if the collectionSize or pageSize values change */
  public ngOnChanges() {
    this.updateCurrentPaginationState();
  }

  private updateCurrentPaginationState(): void {
    if (this.collectionSize > 0) {
      let _pageSize = this.pageSize;
      if (this.pageSize <= 0) {
        _pageSize = this.collectionSize;
      }

      this.totalPages = new Array(Math.ceil(this.collectionSize / _pageSize));

      this.currentPaginationState = 'LOWER';

      if (this.totalPages.length <= 6) {
        this.currentPaginationState = 'LOWER';
      } else {
        if (this.currentPage < 5) {
          this.currentPaginationState = 'LOWER';
        } else if (this.totalPages.length > 6 &&  this.currentPage >= 5 && this.currentPage <= this.totalPages.length - 4) {
          this.currentPaginationState = 'MID';
        } else {
        // this.totalPages.length > 5 && this.currentPage > this.totalPages.length - 4
          this.currentPaginationState = 'UPPER';
        }
      }
    }
  }

  /** Set page number */
  protected selectPageNumber(pageNumber: number) {
    this.currentPage = pageNumber;
    this.callbackFunction.emit(this.currentPage);
    this.updateCurrentPaginationState();
  }

  /** Set next page number */
  protected next() {
    const nextPage = this.currentPage + 1;
    if (nextPage <= this.totalPages.length) {
      this.selectPageNumber(nextPage);
    }
  }

  /** Set previous page number */
  protected previous() {
    const previousPage = this.currentPage - 1;
    if (previousPage >= 1) {
      this.selectPageNumber(previousPage);
    }
  }
}
